<template>
  <div :class="col">
    <div class="alert" :class="[type]" role="alert" :style="{ marginBottom: marginBottom }">
      <b v-if="header">
        <slot name="header"> {{ header }} </slot> &nbsp;
      </b>

      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    col: {
      type: String,
      default: 'col-lg-12'
    },
    header: {
      type: String,
      default: 'Uwaga!'
    },
    marginBottom: {
      type: String,
      default: '20px'
    },
    alertType: {
      type: String,
      default: 'warning'
    }
  },
  data() {
    return {};
  },
  computed: {
    type() {
      return this.alertType.startsWith('alert-') ? this.alertType : 'alert-' + this.alertType;
    }
  }
};
</script>
